import { useSelector } from 'react-redux';
import { AppState } from './app.state';

export const useGameReducer = () => useSelector((state: AppState) => state.gameReducer);
export const useUsers = () => useSelector((state: AppState) => state.gameReducer.users);
export const useUser = (id) => useSelector((state: AppState) => state.gameReducer.users.find(u => u.user.id === id));
